/*
 * Set up footnote links so that when we link back to the footnote marker in the
 * text the page is scrolled to where it was when we clicked it rather than
 * scrolling the marker to the top of the page.
 */

let scrollFrom = { x: 0, y: 0, hash: "" };

const goToNote = (e) => {
  // Save the current scroll position so if we link back to here we
  // can come exactly to the same position.
  scrollFrom = {
    x: window.pageXOffset,
    y: window.pageYOffset,
    hash: "#" + e.currentTarget.id,
  };
  return true;
};

const backToNote = (e) => {
  if (scrollFrom.hash === e.currentTarget.hash) {
    window.location = e.currentTarget.href;
    window.scrollTo(scrollFrom.x, scrollFrom.y);
    return false;
  } else {
    return true;
  }
};

document.querySelectorAll(".marker").forEach(e => e.onclick = goToNote);
document.querySelectorAll(".backlink").forEach(e => e.onclick = backToNote);
